import styled from 'foundations-theming/utils';
// @ts-ignore not typed yet
import { getGridLayoutTreeElement } from 'layout-dnd-utils/nodePositions/nodePositionGridLayoutTreeUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledGridOverlay = styled.div.withConfig({
  displayName: "GridOverlay__StyledGridOverlay"
})([".hs-private.hs-private.hs-private &{position:absolute;height:", ";width:", ";top:", "px;left:", "px;overflow:hidden;z-index:-2;background-color:transparent;display:grid;grid-template-columns:", ";grid-template-rows:", ";row-gap:", ";column-gap:", ";}"], ({
  $height
}) => $height, ({
  $width
}) => $width, ({
  $top
}) => $top, ({
  $left
}) => $left, ({
  $templateColumns
}) => $templateColumns, ({
  $templateRows
}) => $templateRows, ({
  $rowGap
}) => $rowGap, ({
  $columnGap
}) => $columnGap);
const StyledGridCell = styled.div.withConfig({
  displayName: "GridOverlay__StyledGridCell"
})([".hs-private.hs-private.hs-private &{background-color:", ";", " ", " opacity:0.5;border-color:", ";border-width:", ";border-style:dashed;block-size:100%;inline-size:100%;}"], ({
  $isHighlighted,
  theme
}) => $isHighlighted ? theme.color['fill-info-subtle'] : theme.color['fill-transparent-default'], ({
  $rowsSpanned
}) => $rowsSpanned && `grid-row: span ${$rowsSpanned};`, ({
  $columnsSpanned
}) => $columnsSpanned && `grid-column: span ${$columnsSpanned};`, ({
  theme
}) => theme.color['fill-info-default'], ({
  theme
}) => theme.borderWidth['100']);
export const NEXT_FREE_CELL_ID = 'next-free-cell';
function getGridElement(gridContainerNode) {
  if (!gridContainerNode) {
    return null;
  }
  return getGridLayoutTreeElement(gridContainerNode)[0];
}
function getGridSpanning(childNode, activeBreakpointName) {
  var _childNode$getValue$s2;
  if (childNode.isContainer()) {
    var _childNode$getValue$s;
    return ((_childNode$getValue$s = childNode.getValue().styles.breakpointStyles[activeBreakpointName]) === null || _childNode$getValue$s === void 0 ? void 0 : _childNode$getValue$s.gridSpanning) || {};
  }
  return ((_childNode$getValue$s2 = childNode.getValue().styles.editorProvidedModuleBreakpointStyles) === null || _childNode$getValue$s2 === void 0 || (_childNode$getValue$s2 = _childNode$getValue$s2.breakpointStyles[activeBreakpointName]) === null || _childNode$getValue$s2 === void 0 ? void 0 : _childNode$getValue$s2.gridSpanning) || {};
}
export default function GridOverlay({
  targetedGridCellId,
  gridContainerNode,
  activeBreakpointName,
  top,
  left
}) {
  const gridElement = getGridElement(gridContainerNode);
  if (!gridElement) {
    return null;
  }
  const {
    gridTemplateColumns,
    gridTemplateRows,
    rowGap,
    columnGap,
    height,
    width
  } = window.getComputedStyle(gridElement);
  const gridTemplateColumnsArray = gridTemplateColumns.split(' ');
  const gridTemplateRowsArray = gridTemplateRows.split(' ');
  let freeCells = gridTemplateColumnsArray.length * gridTemplateRowsArray.length;
  const childNodes = gridContainerNode.getChildNodes();
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsxs(StyledGridOverlay, {
      $templateColumns: gridTemplateColumns,
      $templateRows: gridTemplateRows,
      $rowGap: rowGap,
      $columnGap: columnGap,
      $top: top,
      $left: left,
      $height: height,
      $width: width,
      children: [childNodes.map(child => {
        var _spanning$rowsSpanned, _spanning$columnsSpan;
        const spanning = getGridSpanning(child, activeBreakpointName);

        // eslint-disable-next-line react-hooks/immutability
        freeCells -= ((_spanning$rowsSpanned = spanning.rowsSpanned) !== null && _spanning$rowsSpanned !== void 0 ? _spanning$rowsSpanned : 1) * ((_spanning$columnsSpan = spanning.columnsSpanned) !== null && _spanning$columnsSpan !== void 0 ? _spanning$columnsSpan : 1);
        return (
          /*#__PURE__*/
          // @bend-expect trellis-tokenized
          _jsx(StyledGridCell, {
            "data-hs-grid-overlay-cell-id": child.getId(),
            "data-hs-grid-cell-is-highlighted": targetedGridCellId === child.getId(),
            $rowsSpanned: spanning.rowsSpanned,
            $columnsSpanned: spanning.columnsSpanned,
            $isHighlighted: targetedGridCellId === child.getId()
          }, child.getId())
        );
      }), Array.from({
        length: freeCells
      }).map((_, i) =>
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsx(StyledGridCell, {
        $isHighlighted: targetedGridCellId === NEXT_FREE_CELL_ID && i === 0
      }, i))]
    })
  );
}